'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Field", {
    enumerable: true,
    get: function() {
        return Field;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _renderField = require("./renderField");
const _useField = require("./useField");
const _useFieldStylesstyles = require("./useFieldStyles.styles");
const _index = require("../../contexts/index");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Field = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useField.useField_unstable)(props, ref);
    (0, _useFieldStylesstyles.useFieldStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useFieldStyles_unstable')(state);
    const context = (0, _index.useFieldContextValues_unstable)(state);
    return (0, _renderField.renderField_unstable)(state, context);
});
Field.displayName = 'Field';
